import { createContext } from "react";

import useStacksRequiringAttention from "./useStacksRequiringAttention";

type StacksRequiringAttentionContextProps = ReturnType<typeof useStacksRequiringAttention>;

export const StacksRequiringAttentionContext = createContext<
  StacksRequiringAttentionContextProps | undefined
>(undefined);
StacksRequiringAttentionContext.displayName = "StacksRequiringAttentionContext";
